import { ResponseService } from './response.service';
import { ReplaySubject } from 'rxjs/Rx';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class MessagesService {

  private oConversations = new ReplaySubject(1);
  private oConversationMessages = new ReplaySubject(1);
  public states = {};


  constructor(
    private apiService: ApiService,
    private responseService: ResponseService
  ) {
    this.states = {
      2: 'Zamknięty',
      3: 'Zamkniety',
      9: 'Zmergowany',
      1: 'Nowy',
      4: 'Otwarty',
      7: 'Oczekujący na zamknięcie',
      8: 'Oczukejący na zamknięcie',
      6: 'Otwarty',
      5: 'Usuniety'
    };
  }


  getConversations(company_id, page) {
    return this.apiService.get('/conversations/list?company_id=' + company_id + '&page=' + page);
      // .subscribe(
      // (response) => {
      //   const conversations = this.responseService.success(false, response);
      //   (this.oConversations).next(conversations);
      // },
      // (error) => {
      //   this.oConversations = new ReplaySubject(1);
      //   this.responseService.error(error);
      // }
      // );
    // return this.oConversations;
  }

  getConversation(conversationID, company_id) {
    this.apiService.get('/conversations/' + conversationID + '?company_id=' + company_id).subscribe(
      (response) => {
        const data = this.responseService.success(false, response);
        this.oConversationMessages.next(data);
      },
      (error) => {
        this.oConversationMessages = new ReplaySubject(1);
        this.responseService.error(error);
      }
    );
    return this.oConversationMessages;
  }

  sendMessage(messageData) {
    this.apiService.post('/message', messageData).subscribe(
      (response) => {
        this.responseService.success(false, response);
      },
      (error) => {
        this.responseService.error(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/messages.service.ts